<template>
  <FormItem label="调度配置" prop="cronOutput">
    <Input
      v-model="inputCronData"
      class="cron-input"
      placeholder="corn表达式"
    />
    <Select
      v-if="oneSelect === 'MIN'"
      v-model="zeroSelect"
      class="margin-right"
      style="width: 80px"
    >
      <Option v-for="item in zeroList" :key="item.value" :value="item.value">
        {{ item.label }}
      </Option>
    </Select>
    <Select
      v-model="oneSelect"
      style="width: 80px"
      class="margin-right"
      @on-change="selectOneChange"
    >
      <Option v-for="item in oneList" :key="item.value" :value="item.value">
        {{ item.label }}
      </Option>
    </Select>
    <Select
      v-if="towList.length > 0"
      v-model="towSelect"
      class="margin-right"
      style="width: 80px"
    >
      <Option v-for="item in towList" :key="item.value" :value="item.value">
        {{ item.label }}
      </Option>
    </Select>
    <Select
      v-if="threeList.length > 0"
      v-model="threeSelect"
      class="margin-right"
      style="width: 80px"
    >
      <Option v-for="item in threeList" :key="item.value" :value="item.value">
        {{ item.label }}
      </Option>
    </Select>
    <Select
      v-if="selectHourAndMinues"
      v-model="fourSelect"
      class="margin-right"
      style="width: 80px"
    >
      <Option v-for="item in fourList" :key="item.value" :value="item.value">
        {{ item.label }}
      </Option>
    </Select>
    <Select
      v-if="selectHourAndMinues"
      v-model="fiveSelect"
      class="margin-right"
      style="width: 80px"
    >
      <Option v-for="item in fiveList" :key="item.value" :value="item.value">
        {{ item.label }}
      </Option>
    </Select>
  </FormItem>
</template>
<script>
export default {
  // model: {
  //   prop: "cronData",
  //   event: "parent-event",
  // },
  props: {
    cronData: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      zeroSelect: 0,
      oneSelect: "MIN",
      towSelect: "分钟",
      threeSelect: "",
      fourSelect: "",
      fiveSelect: "",
      zeroList: [],
      oneList: [],
      towList: [],
      threeList: [],
      fourList: [],
      fiveList: [],
      selectHourAndMinues: false,
      inputCronData: "",
      TIMEDATA: {
        minuesList: [],
        hourList: [],
        weekList: [
          { value: "2", label:"星期一" },
          { value: "3", label:"星期二"},
          { value: "4", label:"星期三" },
          { value: "5", label: "星期四" },
          { value: "6", label: "星期五" },
          { value: "7", label: "星期六" },
          { value: "1", label: "星期日" },
        ],
        monthList: [],
        dayList: [],
        selectType: [
          { value: "MIN", label: "分钟" },
          { value: "HOUR", label: "每小时" },
          { value: "DAY", label: "每天" },
          { value: "WEEK", label: "每周"},
          { value: "MONTH", label: "每月"},
          { value: "YEAR", label: "每年"},
        ],
      },
    };
  },
  computed: {
    timeToCron() {
      if (this.oneSelect === "MIN") {
        return `0 0/${this.zeroSelect} * * * ?`;
      } else if (this.oneSelect === "HOUR") {
        return `0 ${this.towSelect} 0/1 * * ?`;
      } else if (this.oneSelect === "DAY") {
        return `0 ${this.fiveSelect} ${this.fourSelect} 1/1 * ?`;
      } else if (this.oneSelect === "WEEK") {
        return `0 ${this.fiveSelect} ${this.fourSelect} ? * ${this.towSelect}`;
      } else if (this.oneSelect === "MONTH") {
        return `0 ${this.fiveSelect} ${this.fourSelect} ${this.threeSelect} * ?`;
      } else if (this.oneSelect === "YEAR") {
        return `0 ${this.fiveSelect} ${this.fourSelect} ${this.threeSelect} ${this.towSelect} ? *`;
      } else {
        return "";
      }
    },
  },
  watch: {
    timeToCron(val) {
      this.inputCronData = val;
    },
    inputCronData(val) {
      this.$emit("updateCron", val);
    },
    cronData(val) {
      this.inputCronData = val;
    },
  },
  created() {
    for (let i = 0; i < 60; i++) {
      this.TIMEDATA.minuesList.push({
        value: i,
        label:
          i < 10
            ? "0" + i + "分"
            : String(i) +"分",
      });
    }
    for (let i = 0; i < 24; i++) {
      this.TIMEDATA.hourList.push({
        value: i,
        label:
          i < 10
            ? "0" + i +"时"
            : String(i) + "时",
      });
    }
    for (let i = 1; i <= 12; i++) {
      this.TIMEDATA.monthList.push({
        value: i,
        label:
          i < 10
            ? "0" + i + "月"
            : String(i) +"月",
      });
    }
    for (let i = 1; i <= 31; i++) {
      this.TIMEDATA.dayList.push({
        value: i,
        label:
          i < 10
            ? "0" + i + "日"
            : String(i) + "日",
      });
    }
    let tempArr = [];
    for (let i = 0; i < 60; i++) {
      tempArr.push({
        value: i,
        label:
          i < 10
            ? `每0` + i
            : "每" + String(i),
      });
    }
    this.zeroList = tempArr;
    this.oneList = this.TIMEDATA.selectType;
    this.fourList = this.TIMEDATA.hourList;
    this.fiveList = this.TIMEDATA.minuesList;
  },
  methods: {
    selectOneChange(value) {
      if (value === "MIN") {
        this.zeroSelect = this.zeroList[0].value;
        this.towList = [];
        this.threeList = [];
        this.selectHourAndMinues = false;
      } else if (value === "HOUR") {
        this.towList = this.TIMEDATA.minuesList;
        this.towSelect = this.towList[0].value;
        this.selectHourAndMinues = false;
      } else if (value === "DAY") {
        this.selectHourAndMinues = true;
        this.towList = [];
        this.threeList = [];
        this.fourSelect = this.fourList[0].value;
        this.fiveSelect = this.fiveList[0].value;
      } else if (value === "WEEK") {
        this.selectHourAndMinues = true;
        this.threeList = [];
        this.towList = this.TIMEDATA.weekList;
        this.towSelect = this.towList[0].value;
        this.fourSelect = this.fourList[0].value;
        this.fiveSelect = this.fiveList[0].value;
      } else if (value === "MONTH") {
        this.selectHourAndMinues = true;
        this.towList = [];
        this.threeList = this.TIMEDATA.dayList;
        this.threeSelect = this.threeList[0].value;
        this.fourSelect = this.fourList[0].value;
        this.fiveSelect = this.fiveList[0].value;
      } else if (value === "YEAR") {
        this.selectHourAndMinues = true;
        this.towList = this.TIMEDATA.monthList;
        this.threeList = this.TIMEDATA.dayList;
        this.towSelect = this.towList[0].value;
        this.threeSelect = this.threeList[0].value;
        this.fourSelect = this.fourList[0].value;
        this.fiveSelect = this.fiveList[0].value;
      }
    },
    setDispatch(cronData) {
      if (!cronData) return;
      // $t('message.newUitemplate.will')corn$t('message.newUitemplate.Formatistransformedintotimeformat')0 2 2 3 * * ?
      const tepArr = this.cronData.split(" ");
      // $t('message.newUitemplate.Todeterminewhetherselectedyearfirst')
      if (tepArr.length >= 7) {
        this.oneSelect = "YEAR";
        this.selectHourAndMinues = true;
        this.towList = this.TIMEDATA.monthList;
        this.threeList = this.TIMEDATA.dayList;
        this.towSelect = Number(tepArr[4]);
        this.threeSelect = Number(tepArr[3]);
        this.fourSelect = Number(tepArr[2]);
        this.fiveSelect = Number(tepArr[1]);
      } else if (
        tepArr[4] === "*" &&
        tepArr[3] !== "*" &&
        tepArr[3] !== "1/1" &&
        tepArr[3] !== "?"
      ) {
        this.selectHourAndMinues = true;
        this.oneSelect = "MONTH";
        this.towList = [];
        this.threeList = this.TIMEDATA.dayList;
        this.threeSelect = Number(tepArr[3]);
        this.fourSelect = Number(tepArr[2]);
        this.fiveSelect = Number(tepArr[1]);
      } else if (tepArr[5] !== "?") {
        this.oneSelect = "WEEK";
        this.selectHourAndMinues = true;
        this.towList = this.TIMEDATA.weekList;
        this.threeList = [];
        this.towSelect = tepArr[5];
        this.fourSelect = Number(tepArr[2]);
        this.fiveSelect = Number(tepArr[1]);
      } else if (
        tepArr[4] === "*" &&
        tepArr[3] === "1/1" &&
        tepArr[2] !== "*" &&
        tepArr[2] !== "0/1"
      ) {
        this.oneSelect = "DAY";
        this.selectHourAndMinues = true;
        this.towList = [];
        this.threeList = [];
        this.fourSelect = Number(tepArr[2]);
        this.fiveSelect = Number(tepArr[1]);
      } else if (
        tepArr[4] === "*" &&
        tepArr[3] === "*" &&
        tepArr[2] === "0/1"
      ) {
        this.oneSelect = "HOUR";
        this.towList = this.TIMEDATA.minuesList;
        this.towSelect = Number(tepArr[1]);
      } else if (tepArr[4] === "*" && tepArr[3] === "*" && tepArr[2] === "*") {
        this.zeroSelect = Number(tepArr[1].substring(2));
        this.oneSelect = "MIN";
        this.threeList = [];
        this.selectHourAndMinues = false;
      }
    },
  },
};
</script>
<style>
.cron-input {
  margin-bottom: 10px;
}
</style>

